import React, { useState } from 'react';
import styled from 'styled-components';
import { getGravatar } from '../services/gravatar.service';
import SpinnerComponent from './Spinner.component';
import { getRef } from '../utils/ref';

export interface AvatarProps extends getRef<any> {
  src: string;
  size?: number;
  gravatar?: boolean;
  handleClick?: Function;
}

export const StyledAvatar = styled.div<{
  size: number;
}>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 8px;
  transition: all 0.3s;

  & > img {
    border-radius: 8px;
  }
`;

const AvatarComponent = ({
  getRef,
  src: _src,
  size = 32,
  gravatar = true,
  handleClick,
}: AvatarProps) => {
  const [isLoad, setLoad] = useState(false);
  const src = gravatar ? getGravatar(_src, size) : _src;

  return (
    <StyledAvatar
      size={size}
      ref={getRef}
      onClick={() => handleClick && handleClick()}
    >
      <img
        src={src}
        style={{ display: isLoad ? 'block' : 'none' }}
        onLoad={() => setLoad(true)}
        width={size}
        height={size}
        alt="img"
      />
      {!isLoad && <SpinnerComponent size="small" />}
    </StyledAvatar>
  );
};

export default AvatarComponent;
